import { BoxProps, TextNewProps } from '@jfs/ui-new'
import { Colors } from './../../util/util'

const height = 33

const styles = {
  buttonUnderlayColor: Colors.LIGHT_GREY,
  container: {
    borderRadius: 4,
    height,
    flexDirection: 'row',
    overflow: 'hidden',
    borderColor: 'DISABLED_GREY',
    borderWidth: 1,
    backgroundColor: 'WHITE',
    marginRight: 'auto',
  } as BoxProps,
  containerText: {
    height,
    flexDirection: 'row',
    overflow: 'hidden',
  } as BoxProps,
  seperator: {
    borderWidth: 0.5,
    borderColor: 'DISABLED_GREY',
    opacity: 0.2,
  } as BoxProps,
  seperatorText: {
    display: 'none',
  } as BoxProps,
  textStyle: {
    lineHeight: height,
    color: 'BLACK_21',
    fontSize: 12,
    fontWeight: '500',
    textAlign: 'center',
  } as TextNewProps,
}
export default styles
